import { useEffect, useState } from 'react';
import api from '../../api/axios';

import styles from '../dash_styles/modifyshop.module.css';

const ModifyShop = () => {
    const [pageData, setPageData] = useState({});

    const [formData, setFormData] = useState({
        title: '',
        intro: ''
    });

    const fetchProductPageData = async () => {
        try {
            const res = await api.get('/productpagedata');
            setPageData(res.data);
        } catch (error) {
            console.error('Error fetching product page data', error);
        }
    };

    const handleUpdateSubmit = async (e) => {
        e.preventDefault();
        try {
            await api.put('/productpage/edit', formData);
            await fetchProductPageData();
            setFormData({
                title: '',
                intro: ''
            });
        } catch (error) {
            console.error('Error updating product page data', error);
            alert('Failed to update product data');
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    }

    useEffect(() => {
        fetchProductPageData();
    }, []);

    return (
        <div className={styles.mainContainer}>
            <div className={styles.pageEdit}>
                <div className={styles.mainTableContainer}>
                    <div className={styles.labelContainer}>
                        <div className={styles.label}>
                            <p>Landing page management</p>
                        </div>
                        <div className={styles.filterOrder}>
                            
                        </div>
                    </div>
                    <div className={styles.outerTable}>
                        <form onSubmit={handleUpdateSubmit}>
                            <table>
                                <thead>
                                    <tr>
                                        <th className={styles.col1}>content location</th>
                                        <th className={styles.col2}>content type</th>
                                        <th className={styles.col3}>content</th>
                                        <th className={styles.col4}>input</th>
                                        <th className={styles.col5}>action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Main title</td>
                                        <td>Text</td>
                                        <td>{pageData?.title}</td>
                                        <td>
                                            <input
                                                type='text'
                                                name='title'
                                                value={formData.title}
                                                placeholder="Enter new title"
                                                onChange={handleInputChange}
                                            />
                                        </td>
                                        <td><button type='submit'>Apply change</button></td>
                                    </tr>
                                    <tr>
                                        <td>Intro</td>
                                        <td>Text</td>
                                        <td>{pageData?.intro}</td>
                                        <td>
                                            <textarea
                                                name='intro'
                                                onChange={handleInputChange}
                                                className={styles.tableArea}
                                                value={formData.intro}
                                                placeholder="Enter new intro"
                                            ></textarea>
                                        </td>
                                        <td><button type='submit'>Apply change</button></td>
                                    </tr>
                                   
                                </tbody>
                            </table>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModifyShop;